import React, { Fragment, useEffect } from "react";
import Store from "./../../content/Store";
import ChooseButton from "./../shared/ChooseButton";
import Contentify from "../../content/Contentify";
import styles from "../../assets/css/modules/makeAClaim/choose-claim-type.css";
import MemberHelper from "../../helpers/MemberHelper";
import { connect } from "react-redux";
import {
  updateMakeAClaimProperties,
  reset,
  updateNavigation
} from "../../actions/makeAClaim/MakeAClaimActions";
import {
  AUTHORISE_TREATMENT,
  CLAIM_BACK,
  CHOSEN_CLAIM_TYPE
} from "./Constants";
import Scroll from "react-scroll";
import ClaimsToBankNavigation from "./ClaimsToBankNavigation";


export const mapStateToChooseClaimType = ({
  makeAClaimReducer,
  policyReducer
}) => {
  const selectedPolicy = policyReducer && policyReducer.selectedPolicy;
  const currentMember = MemberHelper.getCurrentLoggedInMemberFromPolicy(
    selectedPolicy
  );
  return {
    IsInternalView:
    policyReducer &&
    policyReducer.policyDetails &&
    policyReducer.policyDetails.IsInternalView,
    claimType: makeAClaimReducer.claimType,
    isInternational: policyReducer.selectedPolicy.IsInternational,
    MemberBank: currentMember?.MemberBankDetail,
    IsChildOnlyPolicy: policyReducer.selectedPolicy?.IsChildOnlyPolicy,
  };
};

export const ChooseClaimType = (props) => {
 
  const ClaimsClickhandler=()=>{
    console.log("ClaimsClickhandler");
    props
    .updateNavigation(true);
  };
  useEffect(()=>{
    if(props.onlyDisplayClaimback)
    {
      const propsToUpdate = {
                claimType: CLAIM_BACK
      };
      props.updateMakeAClaimProperties(propsToUpdate);
      props.showBankSection(true);

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[props.onlyDisplayClaimback]);
  return (
    <Fragment>
      <div className="row">
        <p id="selectClaimTypeLabel" className={styles.label + " col"}>
          {!props.onlyDisplayClaimback && props.content.selectClaimTypeLabel}
        </p>
      </div>
      <div className={"row " + styles.buttonWrapper}>
        {!props.onlyDisplayClaimback &&
        <div className="col-lg-6" id="authoriseTreatment">
          <ChooseButton
            icon={props.content.authoriseTreatment.icon}
            title={props.content.authoriseTreatment.heading}
            description={props.content.authoriseTreatment.description}
            onClick={() => {
              props.reset();
              props.updateMakeAClaimProperties({
                claimType: AUTHORISE_TREATMENT
              });
              props.showBankSection(false);
              scrollToName();
            }}
            selected={props.claimType === AUTHORISE_TREATMENT}
            selection={props.claimType !== null ? true : props.selection}
            featureFlagEP={props.featureFlagEP}
          />
        </div>}
        <div className={props.onlyDisplayClaimback?"col-lg-12":"col-lg-6"} id="claimBack">
          <ChooseButton
            icon={props.content.claimBack.icon}
            title={props.content.claimBack.heading}
            description={props.content.claimBack.description}
            onClick={() => {

              props.reset();
              const propsToUpdate = {
                claimType: CLAIM_BACK
              };
              if (props.isInternational) {
                propsToUpdate.action = "uploadDocument";
              }
              props.updateMakeAClaimProperties(propsToUpdate);
              props.showBankSection(true);
              scrollToName();
            }}
            selected={props.claimType === CLAIM_BACK}
            selection={props.claimType !== null ? true : props.selection}
            featureFlagEP={props.featureFlagEP}
          />
        </div>
        
      </div>
      {!props?.IsChildOnlyPolicy  ?
      <>
      {props.bankInfoVisible && props.isCrestDowntime === false ?
        <div className={"row " + styles.boxWrapper}>

          <div className="col-lg-12" id="bankDetails">
            <ClaimsToBankNavigation
              bank={props.content.bank}
              MemberBank={props.MemberBank}
              IsInternalView={props?.IsInternalView}
              ClaimsClickhandler={ClaimsClickhandler}
            />

          </div>
        </div> : null}
          </>
          :null}
    </Fragment>
  );
};

ChooseClaimType.content = Store.ChooseClaimType;

function scrollToName() {
  Scroll.scroller.scrollTo(CHOSEN_CLAIM_TYPE, {
    duration: 750,
    smooth: true
  });
}

export default connect(mapStateToChooseClaimType, {
  updateMakeAClaimProperties,
  reset,
  updateNavigation
})(Contentify(ChooseClaimType));
